export default {
  CARD_NAME: '卖座券'
}
